import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.1 98.593h11.196s20.124-2.62 20.124-22.346c0-12.504-10.331-22.788-23.162-22.32C103.232 43.339 92.481 36 80 36c-16.665 0-30.244 13.018-31.203 29.426C38.373 63.252 28.58 71.2 28.58 81.835c0 17.038 17.88 16.758 17.88 16.758h13.393",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 71.97v51.42M94.023 85.993 80 71.97 65.976 85.993",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgFiles);

export { Memo as default };
//# sourceMappingURL=files.svg.js.map
